import React from "react";
import IconButton from "../IconButton/IconButton";
import "./index.scss";

const IconWithQuantity = ({column, item, onClick}) => {
    const quantity = column.quantity && column.quantity(item);

    return (column.isShow && column.isShow(item) && (
            <div className={"iconWithQuantity"}>
                {!!quantity && (
                    <span className={"iconWithQuantity-quantity"} onClick={onClick}>{quantity}</span>
                )}
                <IconButton isIcon iconName={column.iconName} tooltipText={column.tooltipText} onClick={onClick}/>
            </div>
        )
    )
}

export default IconWithQuantity;